import React from 'react';
import { Phone } from 'lucide-react';

const CostcoFooter = () => (
  <footer className="bg-white border-t-2 border-gray-100">
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="font-bold text-lg mb-4 text-[#00594C]">Costco Loan Services</h3>
            <ul className="space-y-2">
              <li><a href="/costco#calculator" className="text-gray-600 hover:text-[#99DF63] transition-colors">Shop Card Calculator</a></li>
              <li><a href="/costco#book-appointment" className="text-gray-600 hover:text-[#99DF63] transition-colors">Book Appointment</a></li>
              <li><a href="/costco-terms" className="text-gray-600 hover:text-[#99DF63] transition-colors">Terms & Conditions</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-lg mb-4 text-[#00594C]">Contact</h3>
            <ul className="space-y-2">
              <li>
                <a href="tel:+61468007056" className="text-gray-600 hover:text-[#99DF63] transition-colors flex items-center space-x-2">
                  <Phone className="w-4 h-4" />
                  <span>0468 007 056</span>
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-lg mb-4 text-[#00594C]">Legal</h3>
            <ul className="space-y-2">
              <li><a href="/privacy-policy" className="text-gray-600 hover:text-[#99DF63] transition-colors">Privacy Policy</a></li>
              <li><a href="/complaints-policy" className="text-gray-600 hover:text-[#99DF63] transition-colors">Complaints Policy</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-lg mb-4 text-[#00594C]">Locations</h3>
            <ul className="space-y-2">
              <li><a href="/costco/auburn" className="text-gray-600 hover:text-[#99DF63] transition-colors text-sm">Auburn</a></li>
              <li><a href="/costco/casula" className="text-gray-600 hover:text-[#99DF63] transition-colors text-sm">Casula</a></li>
              <li><a href="/costco/marsden-park" className="text-gray-600 hover:text-[#99DF63] transition-colors text-sm">Marsden Park</a></li>
              <li><a href="/costco/ardeer" className="text-gray-600 hover:text-[#99DF63] transition-colors text-sm">Ardeer</a></li>
              <li><a href="/costco/epping" className="text-gray-600 hover:text-[#99DF63] transition-colors text-sm">Epping</a></li>
              <li><a href="/costco/ringwood" className="text-gray-600 hover:text-[#99DF63] transition-colors text-sm">Ringwood</a></li>
              <li><a href="/costco/north-lakes" className="text-gray-600 hover:text-[#99DF63] transition-colors text-sm">North Lakes</a></li>
              <li><a href="/costco/gold-coast" className="text-gray-600 hover:text-[#99DF63] transition-colors text-sm">Gold Coast</a></li>
            </ul>
          </div>
        </div>

        <div className="text-center text-xs text-gray-400 space-y-3 pt-6 border-t border-gray-200">
          <p>
            The information provided on this page is general in nature and does not take into account your objectives, financial situation or needs. You should consider whether it is appropriate for you.
          </p>
          <p>
            Manage Your Loans Pty Ltd ABN 34 652 442 790 is a Credit Representative (540988) of Home Mortgage Plus Pty Ltd ACN 105 991 839 (ACL 392200).
            A referral arrangement is in place between MYL and Costco; however, they are not otherwise affiliated in any other way.
          </p>
          <p>&copy; {new Date().getFullYear()} Manage Your Loans. All rights reserved.</p>
        </div>
      </div>
    </div>
  </footer>
);

export default CostcoFooter;
